import { FC, useEffect, useState } from "react";
import { CatalogListItem } from "../../components/CatalogItem";
import styles from "./catalogList.module.css";

import { useNavigate, useParams } from "react-router-dom";

import { ConfigType } from "../../contexts/AppConfigContext";
import { CatalogType, CategoryType } from "../../contexts/CategoryContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { useCategory } from "../../hooks/useCategory";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";

import { Loading } from "../../components/Loading";
import EmptyState from "../../components/EmptyStates/EmptyState";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { HeaderCategories } from "../../components/HeaderCategories";
import { useOrder } from "../../hooks/useOrder";
import { useSellerInfo } from "../../contexts/sellerInfoContext";

const ListCatalog: FC<any> = () => {
  const { getAppConfig, saveBlockLayout, blockLayout } = useAppConfig();
  const { getCatalogs } = useCategory();
  const [isLoading, setIsLoading] = useState(false);
  const { catalogId,sellerInfo } = useSellerInfo();
  // Array de catálogos com 4 itens
  const [catalogos, setCatalogos] = useState<any[]>([]);
  const navigate = useNavigate();
 
  const [config, setConfig] = useState<ConfigType | void>();
  const { getCatalogSeller, getSellerInfo } = useOrder();
  /* Variavel utilziada para mostrar nomes */
  const [showCatalogName, setShowCatalogName] = useState(true);

  const [useShadow, setUseShadow] = useState(true);

  async function getCatalogos() {
    try {
      const newCatalogs = await getCatalogs();
 

      if (sellerInfo && catalogId) {
        
        const newCatalogFiltered: CatalogType[] = [];
        // regras ->
        //mostrar todos que não possuirem vendedor.
        // Mostrar caso possua vendedor, somente aquele que é do link
        //mostrar todos que não possuirem vendedor.
        newCatalogs.map((catalog) => {
          if (!catalog.sellerCatalog) {
            newCatalogFiltered.push(catalog);
          }
          if (
            catalog.sellerCatalog &&
            catalog.sellerId &&
            parseInt(catalog.sellerId) === sellerInfo.id
          ) {
            if (!catalog.isExclusive) {
              newCatalogFiltered.push(catalog);
            } else if (
              catalog.isExclusive &&
              catalog.id === catalogId
            ) {
              newCatalogFiltered.push(catalog);
            }
          }
        });
        setCatalogos(
          newCatalogFiltered.map((item: any) => ({
            id: item.id,
            nome: item.catalog,
            imagem:
              item.imgCatalog ||
              "https://via.placeholder.com/500x500?text=Sem+Imagem",
          }))
        );
      } else {
        setCatalogos(
          newCatalogs
            .filter((catalog) => !catalog.isExclusive)
            .map((item: any) => ({
              id: item.id,
              nome: item.catalog,
              imagem:
                item.imgCatalog ||
                "https://via.placeholder.com/500x500?text=Sem+Imagem",
            }))
        );
      }
    } catch (error) {
      return {
        success: false,
        data: [],
      };
    }
  }

  async function getConfig() {
    const _config = await getAppConfig();

    if (_config?.content) {
      setShowCatalogName(_config.content.showCatalogName);
      setUseShadow(!_config.content.removeShadow);
    }

    setConfig(_config);
  }

  async function loadData() {
    try {
      setIsLoading(true);
      await getCatalogos();
      await getConfig();
      setIsLoading(false);
    } catch (error) {
      console.error("Error loading data:", error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="subcategory">
      <div className="content-subcategory">
        {isLoading ? (
          <div style={{ width: "100%", height: "calc(100vh)" }}>
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <Header
              background={
                config?.webappcolor.backgroundheader
                  ? config?.webappcolor.backgroundheader
                  : "#F5F5F5"
              }
              colorIcon={
                config?.webappcolor.iconsheader
                  ? config.webappcolor.iconsheader
                  : "#636363"
              }
              logo={config?.icon ? config.icon : ""}
              backgroundCart={
                config?.webappcolor.backgroundcart
                  ? config.webappcolor.backgroundcart
                  : "#FFBA49"
              }
              fontCart={
                config?.webappcolor.fontcart
                  ? config.webappcolor.fontcart
                  : "#000"
              }
              noSales={
                config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                  ? config.content.pdv.noSales
                  : false
              }
            />
            {catalogos.length === 0 ? (
              <>
                <div className={styles.empty_container}>
                  <EmptyState
                    type={"category"}
                    textButton={"Voltar"}
                    colorIcon={
                      config?.webappcolor.iconsheader
                        ? config.webappcolor.iconsheader
                        : "#CEA127"
                    }
                    noShowBackground
                    action={() => navigate(-1)}
                  />
                </div>
              </>
            ) : (
              <div className={styles.category_container}>
                <div className={styles.category_container_header}>
                  <HeaderCategories
                    fontColor={
                      config?.webappcolor.fonttitlebar
                        ? config.webappcolor.fonttitlebar
                        : "#FFFFFF"
                    }
                    backgroundColor={
                      config?.webappcolor.backgroundtitlebar
                        ? config.webappcolor.backgroundtitlebar
                        : "#000000"
                    }
                    categories={["Catálogos"]}
                    blockViewMode={
                      config && config.content.noUseViewMode
                        ? config.content.noUseViewMode
                        : false
                    }
                    inBlocks={blockLayout}
                    setInBlocks={saveBlockLayout}
                  />
                </div>
                <div className={styles.category_container_list}>
                  <CatalogListItem
                    catalog={catalogos}
                    legendColor={""}
                    showName={showCatalogName}
                    isBlock={blockLayout}
                    useShadow={useShadow}
                  />
                </div>
              </div>
            )}
            <Menu
              activeMenu="category"
              fontColor={
                config?.webappcolor.iconsfooter
                  ? config?.webappcolor.iconsfooter
                  : "#636363"
              }
              activeFontColor={
                config?.webappcolor.highlightfooter
                  ? config?.webappcolor.highlightfooter
                  : "#000"
              }
              backgroundMenu={
                config?.webappcolor.backgroundfooter
                  ? config?.webappcolor.backgroundfooter
                  : "#F5F5F5"
              }
              colorIcons={
                config?.webappcolor.iconsfooter
                  ? config?.webappcolor.iconsfooter
                  : "#636363"
              }
              highlightColorIcons={
                config?.webappcolor.highlightfooter
                  ? config?.webappcolor.highlightfooter
                  : "#636363"
              }
              backgroundCart={
                config?.webappcolor.backgroundcart
                  ? config.webappcolor.backgroundcart
                  : "#FFBA49"
              }
              fontCart={
                config?.webappcolor.fontcart
                  ? config.webappcolor.fontcart
                  : "#000"
              }
              noSales={
                config &&
                config?.content &&
                config?.content.pdv &&
                config?.content.pdv.noSales
                  ? config.content.pdv.noSales
                  : false
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ListCatalog;
